import React from 'react';
import { Box } from '@mui/material';

interface Props {
  logoUrl: string;
}

export const SidebarLogo = ({ logoUrl }: Props) => (
  <Box className="logo">
    <img alt="logo" src={logoUrl} />
  </Box>
);
